import React, { useState } from "react";
import { Stack, Typography, Box, Collapse, Button } from "@mui/material";
import { Info, ExpandMore, ExpandLess } from "@mui/icons-material";

export default function VoiceInstructionsBanner() {
  const [expanded, setExpanded] = useState(false);

  return (
    <Stack
      spacing={1}
      sx={{
        bgcolor: "rgba(255, 255, 255, 0.6)",
        px: 2,
        py: 1.5, // slightly increased padding for better spacing
        borderRadius: 2,
        border: "1px solid rgba(59,130,246,0.2)",
      }}
    >
      {/* Header Row */}
      <Stack direction="row" alignItems="flex-start" spacing={1}>
        <Info sx={{ color: "#3b82f6", fontSize: 20, mt: 0.25 }} />

        <Box sx={{ flexGrow: 1 }}>
          <Typography variant="body2" fontWeight={500} color="#1e40af">
            Max 10 lakh records • 10-digit numbers only
          </Typography>

          {/* 2-Line Preview (Hidden when expanded) */}
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{
              display: expanded ? "none" : "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              mt: 0.5,
              lineHeight: 1.4,
            }}
          >
            **🚫 Restricted Voice Content**: Stock market tips, overseas
            education, immigration, political rallies, gaming, dating, medical
            advice, and more are prohibited.
          </Typography>
        </Box>

        {/* Toggle Button */}
        <Button
          size="small"
          onClick={() => setExpanded(!expanded)}
          endIcon={expanded ? <ExpandLess /> : <ExpandMore />}
          sx={{ textTransform: "none", flexShrink: 0, ml: 1 }}
        >
          {expanded ? "Read less" : "Read more"}
        </Button>
      </Stack>

      {/* Expanded Detailed List */}
      <Collapse in={expanded}>
        <Box sx={{ pl: 3.5, pr: 1, pb: 1 }}>
          <Typography
            variant="subtitle2"
            sx={{ mt: 1, mb: 1, fontWeight: "bold", color: "#d32f2f" }}
          >
            **🚫 Restricted Voice Content**
          </Typography>

          <Stack spacing={1}>
            <Typography variant="caption" color="text.secondary">
              📉 Stock market tips, trading advice, and investment
              recommendations are not allowed.
            </Typography>
            <Typography variant="caption" color="text.secondary">
              🎓 Overseas education consultancy, study abroad, MBBS/MBA abroad,
              and admission-related promotions are prohibited.
            </Typography>
            <Typography variant="caption" color="text.secondary">
              🌍 Immigration, visa, PR, and relocation consultancy content is
              not permitted.
            </Typography>
            <Typography variant="caption" color="text.secondary">
              🚫 Any clip that invites, mobilizes, or encourages participation
              in rallies, dharnas, political gatherings, demonstrations,
              protests, or similar events is not allowed to run on the platform.
            </Typography>
            <Typography variant="caption" color="text.secondary">
              🏢 Voice clips must clearly mention the company/brand name.
            </Typography>
            <Typography variant="caption" color="text.secondary">
              ⚠️ Negative, defamatory, hateful, harmful, or emotional marketing
              content is prohibited.
            </Typography>
            <Typography variant="caption" color="text.secondary">
              🎮 Gaming, betting, gambling, and fantasy gaming promotions are
              not allowed.
            </Typography>
            <Typography variant="caption" color="text.secondary">
              ❤️ Dating app and matchmaking promotions or related services are
              not permitted.
            </Typography>
            <Typography variant="caption" color="text.secondary">
              💊 Medical advice, treatment recommendations, healthcare
              consultations, and wellness claims are prohibited.
            </Typography>
            <Typography variant="caption" color="text.secondary">
              🏦 Payment reminders are allowed only for Banks, NBFCs, and their
              authorized collection/recovery partners (Bank/NBFC website listed,
              RBI DLA registered or supported by valid authorization).
            </Typography>
            <Typography variant="caption" color="text.secondary">
              ❌ Payment reminder campaigns by individual companies for
              collecting customer dues are not allowed.
            </Typography>
            <Typography variant="caption" color="text.secondary">
              🔺 MLM, referral earning schemes, pyramid schemes, chain
              marketing, and similar promotional content are strictly
              prohibited.
            </Typography>
          </Stack>
        </Box>
      </Collapse>
    </Stack>
  );
}
